<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item >首页</el-breadcrumb-item>
            <el-breadcrumb-item style="margin-bottom:20px">商城订单列表</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 搜索筛选 -->
        <el-form :inline="true" :model="formInline" label-width="120px" class="user-search">
            <el-form-item label="订单编号">
                <el-input size="small" v-model="formInline.name" :disabled="editFlag" placeholder="手机号"></el-input>
            </el-form-item>
            <el-form-item label="用户手机号">
                <el-input size="small" v-model="formInline.phone" :disabled="editFlag" placeholder="手机号"></el-input>
            </el-form-item>
            <el-form-item label="下单时间">
                <el-date-picker
                    v-model="formInline.time"
                    type="daterange"
                    format="yyyy 年 MM 月 dd 日"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="支付通道">
                <el-select v-model="formInline.payChannel" placeholder="请选择">
                    <el-option
                        v-for="item in channelsList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="">
                <el-button size="small" type="primary" @click="search">搜索</el-button>
                <el-button size="small" @click="empty">重置</el-button>
                <!-- <el-button size="small" type="primary" @click="addClick">创建总经销商</el-button> -->
            </el-form-item>
        </el-form>
        <el-table size="small" :data="listData" max-height="600" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
            <el-table-column show-overflow-tooltip prop="id" label="订单编号" ></el-table-column>
            <el-table-column show-overflow-tooltip prop="status" label="订单状态" >
                <template slot-scope="scope">
                    <div v-if="scope.row.status == 1">已支付</div>
                    <div v-if="scope.row.status == 2">已发货</div>
                    <div v-if="scope.row.status == 3">已完成</div>
                </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="userName" label="下单用户昵称" ></el-table-column>
            <el-table-column show-overflow-tooltip prop="userPhone" label="下单用户手机号"></el-table-column>
            <el-table-column show-overflow-tooltip prop="goodsId" label="商品id" ></el-table-column>
            <el-table-column show-overflow-tooltip prop="storeName" label="商品名称" >
                <template slot-scope="scope">
                    <div>{{ scope.row.goods.name }}</div>
                </template>
            </el-table-column>
            <el-table-column  prop="storeName" label="商品价格" >
                <template slot-scope="scope">
                    <span v-if="scope.row.goods.buyType == 1">{{scope.row.goods.currentPrice}}元</span>
                    <span v-if="scope.row.goods.buyType == 2">{{ scope.row.goods.currentPrice}}元 + {{ scope.row.goods.integral }}积分</span>
                    <span v-if="scope.row.goods.buyType == 3">{{ scope.row.goods.integral }}积分</span>
                </template>
            </el-table-column>
            <el-table-column  prop="storeName" label="运费" >
                <template>
                    <div>包邮</div>
                </template>
            </el-table-column>
            <el-table-column  prop="storeName" label="用户实付" >
                <template slot-scope="scope">
                    <span v-if="scope.row.goods.buyType == 1">{{scope.row.amount}}元</span>
                    <span v-if="scope.row.goods.buyType == 2">{{ scope.row.amount}}元 + {{ scope.row.integral }}积分</span>
                    <span v-if="scope.row.goods.buyType == 3">{{ scope.row.integral }}积分</span>
                </template>
            </el-table-column>
            <el-table-column  prop="createdAt" label="下单时间" >
                <template slot-scope="scope">
                    <div>{{scope.row.createdAt|timestampToTime}}</div>
                </template>
            </el-table-column>
            <el-table-column  prop="payTypeName" label="支付方式" ></el-table-column>
            <el-table-column  prop="payChannelName" label="支付通道" ></el-table-column>
            <el-table-column align="center" label="操作"> 
                <template slot-scope="scope">
                <el-button size="mini" type="text" v-preventReClick @click="seeDetail(scope.row)">查看详情</el-button>
                <el-button size="mini" v-if="scope.row.status == 1" type="text" v-preventReClick @click="sendOutGoods(scope.row)">发货</el-button>
                <el-button size="mini" v-if="scope.row.status == 2" type="text" v-preventReClick @click="ModifyLogistics(scope.row)">修改物流</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        <!-- 查看详情 -->
        <el-dialog title="详情" :visible.sync="seeDetailFlag" width="40%">
                <h4>
                    买家已付款，等待卖家发货
                </h4>
                <div style="line-height: 60px;">用户收货地址</div>
                <el-card class="box-card">
                    <div>张三，177765465456464，辽宁省大连市甘井子区详细地址详细地址详细地址</div>
                </el-card>
                <div style="line-height: 60px;">商品信息</div>
                <el-card class="box-card">
                    <div class="box-card-commodity">
                        <div>
                            <el-image
                            style="width: 100px; height: 100px"
                            :src="queryUrl + seeDetailForm.file.file"
                            :fit="fit"></el-image>
                        </div>
                        <div>
                            <div class="line_height">商品id：{{ seeDetailForm.goods.id }}</div>
                            <div class="line_height">商品名称：{{ seeDetailForm.goods.name }}</div>
                        </div>
                        <div >
                            <div class="line_height">
                                <span v-if="seeDetailForm.goods.buyType == 1">{{seeDetailForm.goods.currentPrice}}元</span>
                                <span v-if="seeDetailForm.goods.buyType == 2">{{ seeDetailForm.goods.currentPrice}}元 + {{ seeDetailForm.goods.integral }}积分</span>
                                <span v-if="seeDetailForm.goods.buyType == 3">{{ seeDetailForm.goods.integral }}积分</span>
                            </div>
                            <div class="line_height" style="text-align:right">x1</div>
                        </div>
                    </div>
                </el-card>
                <div style="line-height: 60px;">订单信息</div>
                <el-card class="box-card">
                    <div class="line_height">商品总价：
                        <span v-if="seeDetailForm.goods.buyType == 1">{{seeDetailForm.goods.currentPrice}}元</span>
                        <span v-if="seeDetailForm.goods.buyType == 2">{{ seeDetailForm.goods.currentPrice}}元 + {{ seeDetailForm.goods.integral }}积分</span>
                        <span v-if="seeDetailForm.goods.buyType == 3">{{ seeDetailForm.goods.integral }}积分</span>
                    </div>
                    <div class="line_height">运费：包邮</div>
                    <div class="line_height">用户实付：
                        <span v-if="seeDetailForm.goods.buyType == 1">{{seeDetailForm.amount}}元</span>
                        <span v-if="seeDetailForm.goods.buyType == 2">{{ seeDetailForm.amount}}元 + {{ seeDetailForm.integral }}积分</span>
                        <span v-if="seeDetailForm.goods.buyType == 3">{{ seeDetailForm.integral }}积分</span>
                    </div>
                    <div class="line_height">订单编号：{{ seeDetailForm.id }}</div>
                    <div class="line_height">订单创建时间：{{seeDetailForm.createdAt|timestampToTime}}</div>
                    <div class="line_height">付款时间：{{seeDetailForm.paydAt|timestampToTime}}</div>
                </el-card>
                <div style="line-height: 60px;">用户信息</div>
                <el-card class="box-card">
                    <div class="line_height">用户id：{{ seeDetailForm.userId }}</div>
                    <div class="line_height">用户昵称：{{ seeDetailForm.userName }}</div>
                    <div class="line_height">用户手机号：{{ seeDetailForm.userPhone }}</div>
                </el-card>
        </el-dialog>

        <!-- 发货 -->
        <el-dialog title="发货" :visible.sync="sendOutGoodsFlag" width="30%">
            <el-card class="box-card">
                <div class="box-card-commodity">
                    <div class="box-card-commodity-shou">收</div>
                    <div style="flex:1">
                        <div>张三 17777777777</div>
                        <div>辽宁省大连市甘井子区打算离开甲氨蝶呤卡机了低价了温度计打</div>
                    </div>
                </div>
            </el-card>
            <el-card class="box-card" style="margin-top:30px">
                <el-form :inline="true" :model="sendOutGoodsForm" label-width="120px" class="user-search">
                    <el-form-item label="物流单号">
                        <el-input size="small" v-model="sendOutGoodsForm.logisticsId" :disabled="editFlag" placeholder="物理单号"></el-input>
                    </el-form-item>
                    <el-form-item label="物流公司">
                        <el-input size="small" v-model="sendOutGoodsForm.logisticsName" :disabled="editFlag" placeholder="物流公司"></el-input>
                    </el-form-item>
                    <el-form-item label="上传凭证">
                        <el-upload
                        class="upload-demo"
                        ref="upload_list"
                        multiple
                        limit="3"
                        :file-list="fileList"
                        accept=".jpg,.jpeg,.png"
                        :http-request="handlePictureCardPreview"
                        :on-remove="handleRemove"
                        :on-exceed="FileExceed">
                        <el-button size="small" type="primary">点击上传</el-button>
                        <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
                        </el-upload>
                    </el-form-item>
                </el-form>
            </el-card>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="sendOutGoodsFlag = false">取消</el-button>
                <el-button size="small" type="primary" :loading="loading" :disabled="submitFlag" v-preventReClick class="title" @click="sendOutGoodsClick()">发货</el-button>
            </div>
        </el-dialog>

        <!-- 修改物流 -->
        <el-dialog title="修改物流" :visible.sync="ModifyLogisticsFlag" width="35%">
            <el-card class="box-card">
                <div class="box-card-commodity">
                    <div class="box-card-commodity-shou">收</div>
                    <div style="flex:1">
                        <div>张三 17777777777</div>
                        <div>辽宁省大连市甘井子区打算离开甲氨蝶呤卡机了低价了温度计打</div>
                    </div>
                </div>
            </el-card>
            <el-card class="box-card" style="margin-top:30px">
                <el-form :inline="true" :model="sendOutGoodsForm" label-width="120px" class="user-search">
                    <el-form-item label="物流单号">
                        <el-input size="small" v-model="ModifyLogisticsData.logisticsId" :disabled="editFlag" placeholder="物理单号"></el-input>
                    </el-form-item>
                    <el-form-item label="物流公司">
                        <el-input size="small" v-model="ModifyLogisticsData.logisticsName" :disabled="editFlag" placeholder="物流公司"></el-input>
                    </el-form-item>
                    <el-form-item label="凭证">
                        <div style="display:flex;width:100%">
                            <div class="imageli" v-for="(item , index ) in ModifyLogisticsData.files" :key="item" @click="imgDelClick(item , index)">
                                <div class="iconStyle">
                                    <img class="logoimg" src="../../../assets/img/del.jpeg" alt="">
                                </div>
                                <el-image
                                style="width: 150px; height: 150px"
                                :src="queryUrl + item.file"
                                :fit="fit"></el-image>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item label="上传凭证">
                        <el-upload
                        class="upload-demo"
                        ref="upload_list"
                        multiple
                        :limit="(3 - ModifyLogisticsData.files.length)"
                        :file-list="fileList"
                        accept=".jpg,.jpeg,.png"
                        :http-request="handlePictureCardPreview"
                        :on-remove="handleRemove"
                        :on-exceed="FileExceed">
                        <el-button size="small" :disabled="ModifyLogisticsData.files.length == 3" type="primary">点击上传</el-button>
                        <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
                        </el-upload>
                    </el-form-item>
                </el-form>
            </el-card>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="ModifyLogisticsFlag = false">取消</el-button>
                <el-button size="small" type="primary" :loading="loading" :disabled="submitFlag" v-preventReClick class="title" @click="ModifyLogisticsSubmit()">保存</el-button>
            </div>
        </el-dialog>
</div>
</template>
<script>
import Pagination from '../../../components/Pagination'
import { loadRecoverOrderList , loadGoodsOrderList , loadPayChannelList  ,
     getGoodsOrderDetail  , getLogistics , 
     deleteLogisticsFile} from '../../../api/userMG'
export default {
    data(){
        return{
            ModifyLogisticsData:{
                files:[]
            },
            ModifyLogisticsFlag:false,
            sendOutGoodsForm:{},
            seeDetailForm:{
                goods:{},
                file:{}
            },
            fileList:[],
            sendOutGoodsFlag:false,
            seeDetailFlag:false ,
            bindingFlag:false,
            activeName:"information",
            detailsFlag:false,
            options:[
                {
                value: '1',
                label: '上架'
                }, {
                value: '0',
                label: '下架'
                },
            ],
            editForm:{},
            editFormVisible:false,
            formInline: {
                page: 1,
                limit: 10,
                phone: '',
                name: '',
                time:[],
                payChannel:''
            },
            machineData:[],
            listData: [], //用户数据
            // 分页参数
            pageparm: {
                currentPage: 1,
                pageSize: 10,
                total: 10
            },
            channelsList:[]
        }
    },
    components: {
        Pagination
    },
    created(){
        this.getdata()
        this.loadPayChannelList()
    },
    methods:{
        imgDelClick(item , index){
            console.log(item)
            deleteLogisticsFile({
                id:item.id
            }).then(res=>{
                if(res.success){
                    getLogistics({
                        orderId:this.ModifyLogisticsData.orderId
                    }).then(res=>{
                        this.ModifyLogisticsData.files = res.logistics.files
                    })
                }else {
                    this.$message.error(res.messages)
                }
            })
        },
        ModifyLogistics(row){
            getLogistics({
                orderId:row.id
            }).then(res=>{
                this.ModifyLogisticsData = res.logistics
                this.ModifyLogisticsFlag = true
            })
        },
        ModifyLogisticsSubmit(){
            let formData = new FormData()
            for(let item of this.fileList){
                formData.append('uplaodFile' , item)
            }
            formData.append('orderId' , this.ModifyLogisticsData.orderId)
            if(this.ModifyLogisticsData.logisticsId != undefined){
                formData.append('logisticsId' , this.ModifyLogisticsData.logisticsId)
            }
            if(this.ModifyLogisticsData.logisticsName != undefined){
                formData.append('logisticsName ' , this.ModifyLogisticsData.logisticsName )
            }
            this.$axios({
                method: "POST",
                url: "/yunyue-houtai/order/saveLogistics",
                headers: {
                "Content-Type": "multipart/form-data",
                token: localStorage.getItem("logintoken"),//token值，根据接口要求传或者不传
                },
                data: formData,
            }).then(res=>{
                console.log(res)
                if(res.data.success == true){
                    this.$message.success('修改成功')
                    this.$refs.upload_list.clearFiles()
                    this.ModifyLogisticsFlag = false
                    this.getdata()
                    this.sendOutGoodsForm = {
                        
                    }
                    this.fileList = []
                }else {
                    this.$message(res.data.messages)
                }
                
            })
        },
        sendOutGoodsClick(){
            let formData = new FormData()
            for(let item of this.fileList){
                formData.append('uplaodFile' , item)
            }
            formData.append('orderId' , this.sendOutGoodsForm.id)
            if(this.sendOutGoodsForm.logisticsId != undefined){
                formData.append('logisticsId' , this.sendOutGoodsForm.logisticsId)
            }
            if(this.sendOutGoodsForm.logisticsName != undefined){
                formData.append('logisticsName ' , this.sendOutGoodsForm.logisticsName )
            }
            this.$axios({
                method: "POST",
                url: "/yunyue-houtai/order/saveLogistics",
                headers: {
                "Content-Type": "multipart/form-data",
                token: localStorage.getItem("logintoken"),//token值，根据接口要求传或者不传
                },
                data: formData,
            }).then(res=>{
                console.log(res)
                if(res.data.success == true){
                    this.$message.success('发货成功')
                    this.$refs.upload_list.clearFiles()
                    this.sendOutGoodsFlag = false
                    this.getdata()
                    this.sendOutGoodsForm = {
                        
                    }
                    this.fileList = []
                }else {
                    this.$message.console.error(res.data.messages)
                }
                
            })
        },
        sendOutGoods(row){
            console.log(row)
            this.sendOutGoodsForm = row
            this.sendOutGoodsFlag = true
            this.$refs.upload_list.clearFiles()
        },
        loadPayChannelList(){
            loadPayChannelList({
                
            }).then(res=>{
                this.channelsList = res.channels
            })
        },
        seeDetail(row){
            getGoodsOrderDetail({
                id:row.id
            }).then(res=>{
                this.seeDetailFlag = true
                this.seeDetailForm = res.order
            })
        },
        handleEdit(row){
            this.detailsFlag = true
        },
        FileExceed(file){
            console.log(file)
            this.$message.error('图片最多可上传3张')
        },
        handlePictureCardPreview(file , fileList) {
            console.log(file)
            console.log(fileList)
            this.fileList.push(file.file)
        },
        handleRemove(file , fileList){
            console.log(file)
            console.log(fileList)
            let data = []
            for(let item of fileList){
                data.push(item.raw)
            }
            this.fileList = data
        },
        addClick(){
            this.editFormVisible = true
        },
        closeDialog(){
            this.editFormVisible = false
        },
        addBanner(){
            this.editFormVisible = true
        },
        empty(){
            this.formInline.page = 1
            this.formInline.limit = 10
            this.formInline.name = '' 
            this.formInline.phone = ''
            this.formInline.time = []
            this.formInline.payChannel = ''
            this.getdata()
        },
        search(){
            this.formInline.page = 1
            this.formInline.limit = 10
            this.getdata()
        },
        getdata(){
            loadGoodsOrderList({
                page:this.formInline.page,
                pageSize:this.formInline.limit,
                id:this.formInline.name,
                phone:this.formInline.phone,
                createdFrom:this.formInline.time[0] == undefined?'':this.formInline.time[0],
                createdTo:this.formInline.time[1] == undefined?'':this.formInline.time[1],
                payChannel:this.formInline.payChannel
            }).then(res=>{
                this.listData = res.pageInfo.list
                this.pageparm.total = res.pageInfo.total
            })
        },
        // 分页插件事件
        callFather(parm) {
            this.formInline.page = parm.currentPage
            this.formInline.limit = parm.pageSize
            this.getdata(this.formInline)
        },
    }
}
</script>
<style>

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .box-card-commodity{
    display: flex;
    justify-content: space-evenly;
    align-items: center;
  }
  .line_height{
    line-height: 45px;
  }
  .box-card-commodity-shou{
    width: 40px;
    height: 40px;
    border-radius: 50%;
    color: #fff;
    background: #8c939d;
    text-align: center;
    line-height: 40px;
    margin-right: 20px;
    font-size: 20px;
  }
  .imageli{
    width: 150px; 
    height: 150px;
    margin-right:10px;
    position: relative;
  }
  .imageli .iconStyle{
    position: absolute;
    left: 50%;
    top: 50%;
    z-index: 999;
    width: 40px;
    height: 40px;
    margin-left:-20px;
    margin-top:-20px;
    display: none;
  }
  .imageli:hover .iconStyle{
    display: block;
  }
</style>


// WEBPACK FOOTER //
// src/views/shoppingMall/commodity/commodityOrder.vue